import React from "react";
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa6";
import { Link } from "react-router-dom";

const SocialsSection = () => {
  return (
    <div className="w-full bg-white rounded-lg shadow-lg p-4 my-4">
      <h2 className="text-xl font-bold text-gray-800 mb-1">Socials</h2>
      <p className="text-sm text-primary font-bold mb-4">Follow us on our socials</p>
      <ul className="w-full">
        <li className="w-full py-3 ps-1 hover:bg-gray-100 transition-colors rounded-md">
          <Link className="flex items-center justify-between font-bold">
            <span>Facebook</span>
            <FaFacebook className="text-2xl md:text-3xl" />
          </Link>
        </li>
        <li className="w-full py-3 ps-1 hover:bg-gray-100 transition-colors rounded-md">
          <Link className="flex items-center justify-between font-bold">
            <span>Instagram</span>
            <FaInstagram className="text-2xl md:text-3xl" />
          </Link>
        </li>
        <li className="w-full py-3 ps-1 hover:bg-gray-100 transition-colors rounded-md">
          <Link className="flex items-center justify-between font-bold">
            <span>Youtube</span>
            <FaYoutube className="text-2xl md:text-3xl" />
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SocialsSection;